import component from './zh-TW/component';
import constants from './zh-TW/constants';
import imm0008 from './zh-TW/form/imm0008';
import imm5406 from './zh-TW/form/imm5406';
import imm5562 from './zh-TW/form/imm5562';
import imm5669 from './zh-TW/form/imm5669';
import globalHeader from './zh-TW/globalHeader';
import menu from './zh-TW/menu';
import pages from './zh-TW/pages';
import pwa from './zh-TW/pwa';
import settingDrawer from './zh-TW/settingDrawer';
import settings from './zh-TW/settings';

export default {
  'navBar.lang': '語言',
  'layout.user.link.help': '幫助',
  'layout.user.link.privacy': '隱私',
  'layout.user.link.terms': '條款',
  'app.preview.down.block': '下載此頁面到本地項目',
  ...pages,
  ...globalHeader,
  ...menu,
  ...settingDrawer,
  ...settings,
  ...pwa,
  ...component,
  ...constants,
  ...imm0008,
  ...imm5406,
  ...imm5562,
  ...imm5669,
};
